// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__MfO1D","left":"styles_left__2-Bjq"};